import {
  AlertTriangle,
  Clock,
  DollarSign,
  Eye,
  Lightbulb,
  RotateCcw,
  Settings as SettingsIcon,
  UserPlus,
  Video,
  Wallet,
  type LucideIcon,
} from 'lucide-react'

export type FeedItemType =
  | 'offer'
  | 'setup'
  | 'manager_invite'
  | 'revision'
  | 'overdue'
  | 'due_soon'
  | 'creative_suggestion'
  | 'video_suggestion'
  | 'upcoming'
  | 'pending_approval'
  | 'payment_received'

export interface FeedItem {
  id: string
  type: FeedItemType
  /** Lower number = higher urgency. Used as the primary sort key. */
  priority: number
  title: string
  subtitle: string
  ctaLabel: string
  ctaPath: string
  brandName: string
  /** Tiebreaker within a priority bucket — ISO date string. Older = more urgent. */
  sortDate?: string
}

export interface FeedTypeStyle {
  label: string
  icon: LucideIcon
  /** Text colour for the icon and label: reads on white (4.5:1 or better) */
  color: string
  /** Soft tint behind the icon */
  tint: string
  /** Urgent items get a coloured left edge so they stand out from the rest */
  urgent?: boolean
  /**
   * Sort key for the feed. Lower = higher urgency.
   * The full ordering lives here so the priority table is readable at a glance —
   * change a number here and the feed re-sorts.
   */
  priority: number
}

export const typeConfig: Record<FeedItemType, FeedTypeStyle> = {
  offer: {
    priority: 1,
    label: 'NEW OFFER',
    icon: DollarSign,
    color: '#3F7A0A',
    tint: '#E8F9D2',
    urgent: true,
  },
  setup: {
    priority: 2,
    label: 'FINISH SETUP',
    icon: SettingsIcon,
    color: '#0E7490',
    tint: '#CFFAFE',
    urgent: true,
  },
  manager_invite: {
    priority: 3,
    label: 'MANAGER INVITE',
    icon: UserPlus,
    color: '#6D28D9',
    tint: '#EDE9FE',
  },
  overdue: {
    priority: 3,
    label: 'OVERDUE',
    icon: AlertTriangle,
    color: '#B91C1C',
    tint: '#FEE2E2',
    urgent: true,
  },
  revision: {
    priority: 3,
    label: 'REVISION REQUESTED',
    icon: RotateCcw,
    color: '#92400E',
    tint: '#FEF3C7',
    urgent: true,
  },
  due_soon: {
    priority: 4,
    label: 'DUE SOON',
    icon: Clock,
    color: '#92400E',
    tint: '#FEF3C7',
  },
  creative_suggestion: {
    priority: 4,
    label: 'MANAGER SUGGESTION',
    icon: Lightbulb,
    color: '#A16207',
    tint: '#FEF9C3',
  },
  video_suggestion: {
    priority: 4,
    label: 'MANAGER SHARED A VIDEO',
    icon: Video,
    color: '#A16207',
    tint: '#FEF9C3',
  },
  upcoming: {
    priority: 5,
    label: 'UPCOMING',
    icon: Clock,
    color: '#1D4ED8',
    tint: '#DBEAFE',
  },
  pending_approval: {
    priority: 6,
    label: 'PENDING BRAND APPROVAL',
    icon: Eye,
    color: '#6D28D9',
    tint: '#EDE9FE',
  },
  payment_received: {
    priority: 7,
    label: 'PAYMENT',
    icon: Wallet,
    color: '#2F5E06',
    tint: '#E8F9D2',
  },
}
